module.exports = __webpack_public_path__ + "static/media/Vas-Loading_1.573e8ba9.gif";